import { render, staticRenderFns } from "./agreement-confirm.vue?vue&type=template&id=fa433e1a&scoped=true&"
import script from "./agreement-confirm.vue?vue&type=script&lang=js&"
export * from "./agreement-confirm.vue?vue&type=script&lang=js&"
import style0 from "./agreement-confirm.vue?vue&type=style&index=0&id=fa433e1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa433e1a",
  null
  
)

export default component.exports